import { API_URL } from "api/API";
import getObsDatetimeApi from "api/forecast/getObsDatetimeApi";
import { obsDatetimeState } from "libs/atoms";
import { convertDateTime } from "libs/utils";
import { useEffect } from "react";
import { useQuery } from "react-query";
import { useSetRecoilState } from "recoil";

const useRunObsDatetime = () => {
  const setObsDatetime = useSetRecoilState(obsDatetimeState);
  const {data} = useQuery([API_URL.FORECAST.GET_OBS_DATETIME], getObsDatetimeApi, {
    refetchInterval: 1000 * 60,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (!data?.obs_datetime) return;

    const ids = Object.keys(data.obs_datetime);
    const obsDatetime = {} as {
      [id: string]: Date
    }

    ids.forEach((id) => {
      obsDatetime[id] = new Date(`${data.obs_datetime[id]}`)
    })
    
    function updateServerTime(add: 0 | 1) {
      const newObsDatetime = {} as {
        [id: string]: {
          date: string;
          time: string;
        }
      }

      ids.forEach((id) => {
        obsDatetime[id].setSeconds(obsDatetime[id].getSeconds() + add);
        newObsDatetime[id] = convertDateTime(obsDatetime[id]);
      });

      setObsDatetime(newObsDatetime);
    }

    updateServerTime(0);

    const interval = setInterval(() => {
      updateServerTime(1);
    }, 1000);

    return () => clearInterval(interval);
  }, [data, setObsDatetime])
}

export default useRunObsDatetime;